import React from 'react';

/**
 * Smooth height expand/collapse using CSS grid 0fr → 1fr + inner fade.
 * @param {{ open: boolean; children: React.ReactNode; className?: string; innerClassName?: string; style?: React.CSSProperties }} props
 */
export function SmoothExpand({ open, children, className = '', innerClassName = '', style }) {
  return (
    <div
      className={`ui-smooth-expand ${open ? 'ui-smooth-expand--open' : ''} ${className}`}
      aria-hidden={open ? undefined : true}
      style={style}
    >
      <div className={`ui-smooth-expand__inner ${innerClassName}`}>{children}</div>
    </div>
  );
}
